import React, { Component } from "react";
import CaseEntries from "../CaseSelector/CaseEntries/CaseEntries";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
	requestPageOfCases,
	searchData,
	searchSortData
} from "./store1/action";
import "../CaseSelector/CaseSelector.css";
import "./Admin.css";
import axios from "axios";
import { apiUri } from "../../config";
import Paginator from "../../hoc/Paginator/Paginator";
import { FaSearch, FaTimes } from "react-icons/fa";
import { FiRefreshCcw } from "react-icons/fi";
import Modal from "react-responsive-modal";
import { NotificationManager } from "react-notifications";
import moment from "moment";

import "react-datepicker/dist/react-datepicker.css";

class CustomCaseManagement extends Component {
	constructor(props) {
	super(props);
	this.state = {
		searchValue: "",
		searchArray: [],
		currentCases: [],
		sortValue: "",
		sortOrder: "",
		searching: false,
		searchData: [],
		openAddModal: false,
		openImportModal: false,
		addCaseData: {
		fillingName: "",
		classPeriodStart: moment(),
		classPeriodEnd: "",
		fillingDate: "",
		classPeriodStart_UI: "",
		classPeriodEnd_UI: "",
		fillingDate_UI: "",
		ticker: "",
		purchased: false,
		enabled: false,
		market: "",
		caseFile: "",
		identifier: "",
		sicCode: "",
		fillingNameError: "",
		classPeriodStartError: "",
		classPeriodEndError: "",
		fillingDateError: "",
		tickerError: "",
		sicCodeError: "",
		marketError: "",
		caseFileError: "",
		indexListIdError: "",
		identifierError: ""
		},
		logsData: []
	};
	this.handleClick = this.handleClick.bind(this);
	this.updateSearchValue = this.updateSearchValue.bind(this);
	this.goToCaseHandler = this.goToCaseHandler.bind(this);
	this.handleSaveFileData = this.handleSaveFileData.bind(this);
	this.handleSaveStatus = this.handleSaveStatus.bind(this);
	this.handleClear = this.handleClear.bind(this);
	
	this.handleCreateCancel = this.handleCreateCancel.bind(this);
	 
	this.importLogs = this.importLogs.bind(this);
	this.getLogs = this.getLogs.bind(this);
	}

	importLogs = () => {
	let self = this;
	localStorage.removeItem("timestamp");
	axios
		.get(apiUri + "/commissions/runImporter")
		.then(json => {
		if (json.data && json.data.statusCode === 200) {
			NotificationManager.success(json.data.statusMessage, "Success");
		} else {
			NotificationManager.error(json.data.statusMessage, "Failure");
		}
		})
		.catch(err => {
		console.log(err);
		});

	this.setState({ openImportModal: true });
	var tmLoc = new Date();
	let T2 = tmLoc.getTime() + tmLoc.getTimezoneOffset() * 60000;
	localStorage.setItem("timestamp", T2);
	axios
		.get(apiUri + "/admin/getLogs")
		.then(json => {
		if (json.data) {
			self.setState({ logsData: json.data.content });
		}
		})
		.catch(err => {
		console.log(err);
		});
	};
	getLogs = () => {
	let self = this;
	axios
		.get(apiUri + "/admin/getLogs")
		.then(json => {
		if (json.data) {
			self.setState({ logsData: json.data.content });
		}
		})
		.catch(err => {
		console.log(err);
		});
	};

	goToCaseHandler = caseId => {
	this.props.history.push("/cases/" + caseId);
	};

	handleSaveFileData = (data, _onCloseModal) => {
	 
	if (data) {
		let StartDate =
		new Date(data.classPeriodStart).getFullYear() +
		"-" +
		("0" + (new Date(data.classPeriodStart).getMonth() + 1)).slice(-2) +
		"-" +
		("0" + new Date(data.classPeriodStart).getDate()).slice(-2);
		let EndDate =
		new Date(data.classPeriodEnd).getFullYear() +
		"-" +
		("0" + (new Date(data.classPeriodEnd).getMonth() + 1)).slice(-2) +
		"-" +
		("0" + new Date(data.classPeriodEnd).getDate()).slice(-2);
		let obj = {
		id: data.id,
		symbol: data.ticker,
		commissionName: data.fillingName,
		classPeriodStart: StartDate,
		classPeriodEnd: EndDate,
		purchased: data.purchased,
		enabled: data.enabled,
		status: data.status,
		sicCode: data.sicCode,
		caseRuleTypeId: data.caseRuleTypeId,
		market: data.market,
		identifier: data.identifier,
		indexListId: data.indexListId,
		caseFile: data.caseFile
		};
		axios
		.post(apiUri + "/commissions/update/" + data.id, obj)
		.then(json => {
			if (json.data && json.data.statusCode === 200) {
			this.props.requestPageOfCases(
				this.props.currentPage,
				this.state.sortValue,
				this.state.sortOrder
			);
			NotificationManager.success(json.data.statusMessage);
			_onCloseModal();
			}
		})
		.catch(err => {
			console.log(err);
		});
	}
	};
	handleSaveStatus = data => {
	if (data) {
		let obj = {
		commissionId: data.id,
		enabled: data.enabled
		};
		axios
		.post(apiUri + "/commissions/updateEnabled", obj)
		.then(json => {
			if (json.data && json.data.statusCode === 200) {
			this.props.requestPageOfCases(
				this.props.currentPage,
				this.state.sortValue,
				this.state.sortOrder
			);
			NotificationManager.success(json.data.statusMessage, "Success");
			}
		})
		.catch(err => {
			console.log(err);
		});
	}
	};
	

	onCloseModal = () => {
	this.setState({ open: false, openAddModal: false });
	};
	oncloseimportModal = () => {
	this.setState({ open: false, openImportModal: false, logsData: [] });
	localStorage.removeItem("timestamp");
	};
	handleSorting = (key, order) => {
	this.setState({ sortValue: key, sortOrder: order });
	let obj = {
		sortValue: key,
		sortOrder: order
	};
	localStorage.setItem("sortParams", JSON.stringify(obj));
	this.props.searchSortData(this.props.currentPage, key, order);
	};
	componentDidMount() {
	 
	let page = this.props.currentPage;;
	this.props.requestPageOfCases(
		page,
		this.state.sortValue,
		this.state.sortOrder
	);
	}
	updateSearchValue(evt) {
	this.setState({ searchValue: evt.target.value });
	}
	handleClick() {
	localStorage.setItem("searchValue", JSON.stringify(this.state.searchValue));
	sessionStorage.setItem('tempSearchValue',this.state.searchValue)
	this.props.searchData(0);
	var obj = JSON.parse(localStorage.getItem("sortParams"));
	if(obj){
	this.setState({
		sortValue:obj.sortValue,
		sortOrder:obj.sortOrder
	})
	setTimeout(()=>{
		this.props.searchSortData(this.props.currentPage, obj.sortValue, obj.sortOrder);
	 },200) 
	}
	}
	handleClear() {
		this.setState({ searchValue: "" });
		localStorage.removeItem("sortParams");
		this.setState({sortOrder:'',sortValue:''})
		localStorage.removeItem("searchValue");
		sessionStorage.removeItem('tempSearchValue')
		this.props.searchData(0);
	}
	
	
	handleCreateCancel() {
	this.setState({ openAddModal: false, addCaseData: {} });
	}

	keyPress(e) {
	if (e.keyCode === 13 || e.keyCode === 10) {
		this.handleClick();
	}
	}
	componentDidUpdate(){
	window.onpopstate  = (e) => {
		e.preventDefault();
		var tempSearchValue = sessionStorage.getItem('tempSearchValue')
		
		if(tempSearchValue){
			setTimeout(()=>{
				localStorage.setItem("searchValue", JSON.stringify(tempSearchValue));
				this.props.searchData(this.props.currentPage);
			 },100)
			
			 this.setState({ searchValue: tempSearchValue })
			 
		}
		var obj = JSON.parse(localStorage.getItem("sortParams"));
		 if(obj){
		 this.setState({
		 sortValue:obj.sortValue,
		 sortOrder:obj.sortOrder
		 })
	//.setItem("sortParams", JSON.stringify(obj));
	
	 setTimeout(()=>{
	 
		this.props.searchSortData(this.props.currentPage, obj.sortValue, obj.sortOrder);
	 },200) 
	
		}
	 }
	}
	render() {
	return (
		<React.Fragment>
		<div
			style={{ display: "flex", justifyContent: "space-between" }}
			className={"CustomCaseManagementTitle"}
		>
			<span>Custom Risk Management</span>
			<div
			style={{
				display: "flex",
				justifyContent: "space-between",
				width: "180"
			}}
			>
			<div
				style={{
				position: "relative",
				width: "207px",
				height: "29px",
				top: "-1px",
				backgroundColor: "#83bed3",
				border: "1px solid rgb(90, 154, 176)",
				borderRadius: "14.5px"
				}}
			>
				<input
				id="search"
				type="text"
				className="searchBox"
				onKeyDown={e => this.keyPress(e)}
				value={this.state.searchValue}
				placeholder="Search"
				onChange={this.updateSearchValue}
				/>
				{this.state.searchValue && (
				<span className="clearIcon" onClick={this.handleClear}>
					x
				</span>
				)}
				<FaSearch className="searchBtn" onClick={this.handleClick} />
			</div>
			&nbsp; &nbsp;
			<button
				className="btn btnS"
				onClick={() => {
				this.importLogs();
				}}
			>
				Import
			</button>
			</div>
		</div>
		{this.props.currentCases.length > 0 ? (
			<CaseEntries
			cases={this.props.currentCases}
			sortValue={this.state.sortValue}
			sortOrder={this.state.sortOrder}
			goToCaseHandler={this.goToCaseHandler}
			handleEdit={this.handleEdit}
			handleDelete={this.handleDelete}
			handleSaveFileData={this.handleSaveFileData}
			handleSaveStatus={this.handleSaveStatus}
			handleSorting={this.handleSorting}
			/>
		) : (
			<div className="widthfull">
			<table className="widthfull">
				<tbody>
				<tr>
				<td className="norecords">
					<span>No Records Found</span>
				</td>
				</tr>
				</tbody>
			</table>
			</div>
		)}
		{this.props.currentCases.length > 0 ? (
			<Paginator
			name={"case-selector"}
			totalPages={this.props.totalPages}
			currentPage={this.props.currentPage}
			setPage={this.props.requestPageOfCases}
			/>
		) : (
			""
		)}

		<Modal
			open={this.state.openImportModal}
			onClose={this.oncloseimportModal}
			focusTrapped={true}
		>
			<input
			type="text"
			value=""
			style={{
				visibility: "visible",
				height: "0px",
				width: "0px",
				opacity: 0
			}}
			/>
			<div className="ModalWindow Modalimport">
			<table>
				<tbody>
				<tr>
					<td width="95%">
					<h3 className="modalHeading">Importer logs</h3>
					</td>
					<td width="5%">
					<FiRefreshCcw
						className="refreshicon"
						onClick={this.getLogs}
					/>
					</td>
					<td width="5%">
					<FaTimes
						className="closeiconLog"
						onClick={this.oncloseimportModal}
					/>
					</td>
				</tr>
				</tbody>
			</table>
			<div className="ModalDivider"></div>
			<div className="logsBlock">
				{this.state.logsData &&
				this.state.logsData.map(logs => <div>{logs}</div>)}
			</div>
			</div>
		</Modal>
		</React.Fragment>
	);
	}
}

const mapStateToProps = state => {
	return {
	currentCases: state.cases.currentCases,
	currentPage: state.cases.currentPage,
	totalCases: state.cases.totalCases,
	totalPages: state.cases.totalPages
	};
};

const mapDispatchToProps = dispatch => {
	return {
	requestPageOfCases: (page, sortValue, sortOrder) =>
		dispatch(requestPageOfCases(page, sortValue, sortOrder)),
	searchData: page => dispatch(searchData(page)),
	searchSortData: (currentPage, sortValue, sortOrder) =>
		dispatch(searchSortData(currentPage, sortValue, sortOrder))
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(CustomCaseManagement));



// WEBPACK FOOTER //
// ./src/components/Admin/CustomCaseManagement.js